import TimeAgo from "react-timeago";
import icelandicStrings from "react-timeago/lib/language-strings/is";
import englishStrings from "react-timeago/lib/language-strings/en";
import buildFormatter from "react-timeago/lib/formatters/buildFormatter";
import { useTranslation } from "react-i18next";

const icelandicFormatter = buildFormatter(icelandicStrings);
const englishFormatter = buildFormatter(englishStrings);

const FormatTimeAgo = ({ date }) => {
  const { i18n } = useTranslation();

  return (
    <TimeAgo
      date={date}
      formatter={i18n.language === "en" ? englishFormatter : icelandicFormatter}
    />
  );
};

export default FormatTimeAgo;
